module.exports = __webpack_public_path__ + "img/DoorBackOutlined.6ecb2470.svg";